import api from './api';

export const normalizeNature = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  .trim().replace(/\s+/g, ' ').toLocaleLowerCase('pt-BR');
export const natureOption = item => ({ value: String(item._id), nome: item.nome, label: item.nome, ativo: item.ativo });

// Bounded, per-session cache; aborted requests never enter it. No rank metadata is stored.
const recent = new Map();
export function clearNatureQueries() { recent.clear(); }
export async function queryNatures(q, page, signal) {
  const key = `${normalizeNature(q)}:${page}`;
  const cached = recent.get(key);
  if (cached && Date.now() - cached.at < 30000) return cached.data;
  const { data } = await api.get('/naturezas', { params: { q: normalizeNature(q), page }, signal });
  if (!signal?.aborted) {
    if (recent.size >= 40) recent.delete(recent.keys().next().value);
    recent.set(key, { at: Date.now(), data });
  }
  return data;
}

// Resolve before saving the report. Name uniqueness makes retry after a lost response idempotent.
export async function resolveNatureSuggestions(report) {
  if (!report.naturezaSugestoes?.length) return report;
  const replacements = new Map();
  for (const suggestion of report.naturezaSugestoes) {
    const { data } = await api.post('/naturezas/sugerir', { nome: suggestion.nome });
    if (!data?._id || !data.ativo) {
      const error = new Error('A sugestão corresponde a uma natureza inativa. Revise a seleção.');
      error.response = { status: 422, data: { message: error.message } };
      throw error;
    }
    replacements.set(suggestion.id, data);
  }
  const ids = [...new Set((report.naturezaIds || []).map(id => String(replacements.get(id)?._id || id)))];
  const next = { ...report, naturezaIds: ids, naturezaId: ids.length === 1 ? ids[0] : '' };
  delete next.naturezaSugestoes;
  return next;
}
